import Promise from 'bluebird';
import CookieDough from 'cookie-dough';

const COOKIE_NAME = 'ajs_ab.traits';

class CookieMetrics {
  constructor(req) {
    // eslint-disable-next-line new-cap
    this.cookie = req ? new CookieDough(req) : CookieDough();
    this.variants = {};
    this.server = !!req;
    this.load();
  }

  prepare() {
    return Promise.resolve().then(() => this.load());
  }

  getCurrentVariantName(variantName) {
    return this.variants[variantName];
  }

  setCurrentVariantName(variantName, value) {
    this.variants[variantName] = value;
    if (!this.server) {
      this.save();
    }
  }

  load() {
    if (!this.cookie || this.loaded) {
      return;
    }

    try {
      this.variants = JSON.parse(this.cookie.get(COOKIE_NAME) || '{}');
    } catch (e) {
      this.variants = {};
    }

    this.loaded = true;
  }

  save() {
    if (!this.cookie) {
      return;
    }

    this.cookie.set(COOKIE_NAME, JSON.stringify(this.variants), {
      maxAge: 31536000000,
      path: '/'
    });
  }
}

export default CookieMetrics;



// WEBPACK FOOTER //
// ./src/modules/ab-express/cookie-metrics.js